
export enum SourceDevice {
	MOBILE = "MOBILE", WEB="WEB"
  }